




















import Vue from 'vue'
import { getOptionAlphabet } from '@/helper'
export default Vue.extend({
  props: {
    sequenceNumber: {
      type: Number
    },
    index: {
      type: Number
    },
    correctOptionNotAvailable: {
      type: Boolean
    },
    statement: {
      type: String
    },
    isChosen: {
      type: Boolean,
      default: false
    },
    isCorrect: {
      type: Boolean,
      default: false
    },
    showingResults: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    requiredPassingGrade: {
      type: Boolean
    },
    correctAnswerGiven: {
      type: Boolean
    }
  },
  computed: {
    outsideBorderColor(): string {
      if (this.isChosen && this.correctOptionNotAvailable === true) return 'border-green-500'
      if (this.showingResults === false) {
        return this.isSelected ? 'border-blue-400' : 'border-gray-400'
      } else {
        if (this.isChosen && this.requiredPassingGrade === true) {
          if (this.correctAnswerGiven === true) return 'border-green-500'
          return 'border-red-500'
        }
        if (this.isChosen && this.isCorrect) {
          return 'border-green-500'
        } else if (this.isChosen && !this.isCorrect) {
          return 'border-red-500'
        } else if (!this.isChosen && this.isCorrect) {
          if (this.requiredPassingGrade === true) {
            return 'border-gray-400'
          } else {
            return 'border-green-500'
          }
        }
      }
      return 'border-gray-400'
    },
    optionColor(): string {
      if (this.isChosen && this.correctOptionNotAvailable === true) return 'bg-green-500'
      if (this.showingResults === false) {
        return this.isSelected ? 'bg-blue-400 text-white' : 'bg-gray-400'
      } else {
        if (this.isChosen && this.requiredPassingGrade === true) {
          if (this.correctAnswerGiven === true) return 'bg-green-500'
          return 'bg-red-500'
        }
        if (this.isChosen && this.isCorrect) {
          return 'bg-green-500'
        } else if (this.isChosen && !this.isCorrect) {
          return 'bg-red-500'
        } else if (!this.isChosen && this.isCorrect) {
          if (this.requiredPassingGrade === true) {
            return 'bg-gray-400'
          } else {
            return 'bg-green-500'
          }
        }
      }
      return 'bg-gray-400'
    }
  },
  methods: {
    toggleSelected() {
      if (this.isSelected === false) {
        this.$emit('selectAnswer', this.sequenceNumber)
      } else {
        this.$emit('unselectAnswer', this.sequenceNumber)
      }
    },
    getOptionAlphabet
  }
})
